import React, { useState, useEffect } from "react";
import { apiPost } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";

function FreelancerAddQuotationModel({
    JobPostData,
    isOpen,
    onClose,
    GetAllPendingJobs,
    setExpandedJob
}) {
    const [ProposedPrice, setProposedPrice] = useState("");
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [Note, setNote] = useState("");
    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (JobPostData) {
            setStartDate(JobPostData?.timeline?.startDate?.split("T")[0] || "");
            setEndDate(JobPostData?.timeline?.endDate?.split("T")[0] || "");
        }
    }, [JobPostData]);

    const handleSubmit = async () => {
        let newErrors = {};
        if (!ProposedPrice) newErrors.ProposedPrice = "Proposed price is required";
        if (!StartDate) newErrors.StartDate = "Start date is required";
        if (!EndDate) newErrors.EndDate = "End date is required";
        if (!Note) newErrors.Note = "Note is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true);
            const payload = {
                JobPost: JobPostData?._id,
                ProposedPrice: Number(ProposedPrice),
                Timeline: {
                    startDate: StartDate,
                    endDate: EndDate,
                },
                Note,
            };

            const response = await apiPost(
                `api/freelance-engineer/CreateBidOnJobPost`,
                payload
            );

            if (response?.data) {
                toast.success(response?.message || "Bid submitted successfully!");
                onClose();
                setExpandedJob(null);
                GetAllPendingJobs();
            } else {
                toast.error(response?.message || "Failed to submit bid");
            }
        } catch (error) {
            console.error("Error submitting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-6 max-w-2xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6 border-b pb-3">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-bold text-gray-800">
                        Submit Your Bid
                    </h2>
                </div>
                <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="text-sm font-medium text-gray-600">
                                Proposed Price (₹)
                            </label>
                            <input
                                type="number"
                                value={ProposedPrice}
                                onChange={(e) => setProposedPrice(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.ProposedPrice && (
                                <p className="text-red-500 text-sm mt-1">{errors.ProposedPrice}</p>
                            )}
                        </div>

                        <div>
                            <label className="text-sm font-medium text-gray-600">Start Date</label>
                            <input
                                type="date"
                                value={StartDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.StartDate && (
                                <p className="text-red-500 text-sm mt-1">{errors.StartDate}</p>
                            )}
                        </div>

                        <div>
                            <label className="text-sm font-medium text-gray-600">End Date</label>
                            <input
                                type="date"
                                value={EndDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.EndDate && (
                                <p className="text-red-500 text-sm mt-1">{errors.EndDate}</p>
                            )}
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-sm font-medium text-gray-600">Note</label>
                            <textarea
                                value={Note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={4}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.Note && (
                                <p className="text-red-500 text-sm mt-1">{errors.Note}</p>
                            )}
                        </div>
                    </div>
                </div>
                
                <div className="mt-8 flex justify-end gap-4 border-t pt-4">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 border rounded-lg hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={IsLoading}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                    >
                        {IsLoading ? "Submitting..." : "Submit Bid"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FreelancerAddQuotationModel;
